import { render, staticRenderFns } from "./create-edge-gateway.vue?vue&type=template&id=35249aa9&scoped=true"
import script from "./create-edge-gateway.vue?vue&type=script&lang=js"
export * from "./create-edge-gateway.vue?vue&type=script&lang=js"
import style0 from "./create-edge-gateway.vue?vue&type=style&index=0&id=35249aa9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35249aa9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
installComponents(component, {VCard,VCol,VContainer,VDivider,VRow,VStepper,VStepperContent,VStepperStep})
